module.exports = __webpack_public_path__ + "img/green.45bbc9aa.png";